{
  "stripe_not_configured": "Stripe payments are not configured yet.",
  "stripe_not_ready": "Subscriptions are not open yet. No payment was made.",
  "stripe_error": "Stripe could not process the request. Try again or contact the administration.",
  "premium_already_active": "Your Premium is already active. Use subscription management.",
  "subscription_exists": "A subscription or payment is already in progress. Open its management to avoid double billing.",
  "premium_required": "Active Premium is required for this customization.",
  "premium_changed": "Your Premium access changed. Reload your profile before trying again.",
  "premium_price_invalid": "The Stripe price must be active at €3.99 per month, inclusive of applicable taxes.",
  "premium_product_unavailable": "This product cannot be found with the current Stripe key. Check the account and test/live mode: no replacement product was created.",
  "premium_product_invalid": "The Premium product must have a prod_ identifier, be active and match the Stripe key's mode.",
  "premium_product_mismatch": "The configured price does not belong to the selected Premium product.",
  "premium_product_price_missing": "Add an active fixed €3.99 monthly price to the existing product, inclusive of applicable taxes.",
  "premium_product_price_ambiguous": "Several compatible prices exist. Choose a default price or set STRIPE_PREMIUM_PRICE_ID.",
  "billing_portal_inactive": "The Stripe portal does not yet support complete subscription management.",
  "billing_live_disabled": "Live payments stay disabled until commercial and tax validation.",
  "billing_url_invalid": "The site URL is not configured for payments.",
  "checkout_unavailable": "The payment page could not be prepared.",
  "checkout_pending": "A payment page or confirmation is already in progress. Try again shortly.",
  "checkout_expiring": "An earlier payment attempt is close to expiring. Wait for it to expire before trying again.",
  "billing_customer_missing": "This account does not have a billing record yet.",
  "billing_environment_mismatch": "Administration must close subscriptions in the other Stripe environment before erasure.",
  "billing_invoice_too_large": "Review this invoice in Stripe.",
  "billing_risk_too_large": "Review this payment in Stripe.",
  "billing_report_too_large": "More than 5,000 transactions: choose a shorter period or use Stripe reports.",
  "billing_subscription_inactive": "This subscription no longer supports renewal management.",
  "billing_payment_not_refundable": "This payment has not been collected in this environment.",
  "billing_refund_amount": "The amount exceeds the remaining refundable balance.",
  "billing_refund_verification_required": "This old request has no recorded result. Check refunds in Stripe before trying again.",
  "premium_image_target": "Choose a card for this portrait, or an avatar/banner without a card.",
  "premium_upload_busy": "An image is already being saved. Try again shortly.",
  "premium_image_invalid": "Use a static PNG, JPEG or WebP up to 15 MB, 4 megapixels and 4096 pixels per side.",
  "premium_image_too_large": "This image exceeds 15 MB. Reduce its size before uploading.",
  "premium_image_limit": "The card or account changed, or the 20-portrait limit was reached.",
  "friend_limit_changed": "The request or your friend limit changed. Reload before trying again.",
  "showcase_limit_changed": "Your showcase limit changed. Reload your profile before trying again.",
  "automation_forbidden": "Bots, AI agents and auto-clickers are forbidden on ANIDEX. Play from your browser or the app.",
  "network_error": "Can’t reach ANIDEX. Check your connection.",
  "http_error": "Error {{status}}.",
  "unexpected": "Something unexpected happened.",
  "payload_too_large": "Request is too large.",
  "not_found": "Route not found.",
  "internal_error": "An internal error occurred.",
  "upgrade_required": "WebSocket connection required.",
  "unauthorized": "Sign in to continue.",
  "validation_error": "Some details are invalid.",
  "invalid_json": "The request body is not valid JSON.",
  "invalid_id": "Invalid identifier.",
  "invalid_cursor": "This history page is no longer valid. Refresh the history.",
  "history_unavailable": "This history could not be read. Try again or check the server logs.",
  "already_claimed": "You already claimed this reward.",
  "quest_character_required": "Choose the card that receives the fragments.",
  "card_not_owned": "You don’t own this card.",
  "ip_taken": "An account already exists from this address.",
  "ip_banned": "This address is banned.",
  "account_busy": "An auction just changed. Try again.",
  "wrong_password": "Incorrect password.",
  "banner_unavailable": "This work can’t be used as a banner.",
  "day_missing": "This month’s calendar can’t be found.",
  "quest_not_completed": "This quest isn’t finished yet.",
  "rarity_unavailable": "No character of this rarity is available right now.",
  "email_taken": "This email address is already in use.",
  "username_taken": "This username is already taken.",
  "turnstile_failed": "The anti-bot check failed. Try again.",
  "human_check_required": "Confirm you are human to keep playing.",
  "account_blocked": "This account is blocked.",
  "invalid_token": "This verification link is invalid or has expired.",
  "already_verified": "Your email address is already verified.",
  "card_locked": "This card is locked (sale, auction, or trade in progress).",
  "already_listed": "This character already has an active listing.",
  "listing_conflict": "This listing just changed. Try again.",
  "listing_sold": "This listing was sold or cancelled.",
  "auction_conflict": "This auction just changed. Try again.",
  "idempotency_key_reused": "This key was already used.",
  "trade_exists": "A trade is already in progress with this player.",
  "trade_conflict": "This trade just changed.",
  "stale_revision": "This offer was updated. Reload the page.",
  "cards_moved": "One of the cards is no longer available. It was sold or moved.",
  "missing_idempotency_key": "The Idempotency-Key header is required.",
  "booster_unavailable": "This booster is unavailable.",
  "invalid_quantity": "That booster quantity isn’t allowed.",
  "concurrent_opening": "Another opening is in progress. Try again in a moment.",
  "invalid_origin": "Request origin is not allowed.",
  "no_session": "Invalid session.",
  "friend_requests_disabled": "This player isn’t accepting friend requests.",
  "already_friends": "You are already friends.",
  "already_pending": "A request is already pending.",
  "cooldown": "Wait a bit before sending this player another request.",
  "friends_full": "You’ve reached the friend limit.",
  "requests_full": "You have too many pending requests.",
  "their_friends_full": "This player has reached their friend limit.",
  "invalid_target": "That action isn’t possible.",
  "already_reported": "You already reported this.",
  "collection_private": "This collection is private.",
  "compare_self": "You can’t compare yourself with yourself.",
  "profile_private": "This profile is private.",
  "invalid_duration": "Invalid auction duration.",
  "too_many_auctions": "You’ve reached the maximum number of active auctions.",
  "auction_not_active": "This auction is no longer active.",
  "has_bids": "You can’t cancel an auction that already has bids.",
  "auction_ended": "This auction has ended.",
  "own_auction": "You can’t bid on your own listing.",
  "already_highest": "You are already the highest bidder.",
  "bid_too_low": "That bid is too low.",
  "use_buyout": "Use buyout for that amount.",
  "no_buyout": "This auction has no buyout price.",
  "max_level": "This card is already at its maximum level.",
  "not_enough_fragments": "You don’t have enough fragments for this upgrade.",
  "upgrade_conflict": "This card just changed. Reload the page.",
  "card_feature_locked": "This customization is not unlocked at your card’s level yet.",
  "card_customization_changed": "This card changed in the meantime. Reload its details before trying again.",
  "fragment_conversion_changed": "These fragments changed in the meantime. Reload your collection before trying again.",
  "invalid_upgrade_cursor": "This cursor is only valid when upgrading all cards.",
  "market_level": "The market isn’t available at your level yet.",
  "price_out_of_bounds": "This price is outside the allowed range for this character.",
  "empty_buyback": "Choose at least one card.",
  "buyback_too_many": "You selected too many cards.",
  "favorite_protected": "A favorite can’t be sold to the system.",
  "buyback_too_small": "A card isn’t worth enough for the system to buy it back.",
  "buyback_conflict": "A card just changed. Reload the page.",
  "invalid_reaction": "Invalid reaction.",
  "invalid_peer": "Invalid conversation.",
  "not_friends": "Messaging is limited to your friends.",
  "client_id_reused": "This client id was already used for another message.",
  "invalid_character": "Character not found.",
  "empty_message": "Add a message or share a card.",
  "message_too_long": "Message is too long.",
  "invalid_sitemap": "Unknown sitemap.",
  "referral_invalid": "This referral code does not exist.",
  "referral_sponsor_unverified": "This sponsor has not verified their account yet.",
  "referral_self": "You cannot use your own code.",
  "referral_cycle": "Someone you referred cannot become your sponsor.",
  "referral_sponsor_newer": "Your sponsor must have joined before you.",
  "referral_already_set": "You already have a sponsor.",
  "referral_window_closed": "A referral code must be entered within {{days}} days of signing up.",
  "retry": "A rare collision happened. Try again."
}
